import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface AdditionalInfoAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const AdditionalInfoAccordion: React.FC<
  AdditionalInfoAccordionProps
> = ({ jobData, expanded, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation('job');

  const mappedData = {
    medicalSpeciality: 'N/A',
    medicalType: 'N/A',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion
      title={t('v2.accordion.additionalInformation')}
      expanded={expanded}
      onChange={onChange}
    >
      <Grid container spacing={3}>
        {renderDetailItem(t('v2.accordion.medicalSpeciality'), mappedData.medicalSpeciality)}
        {renderDetailItem(t('v2.accordion.medicalType'), mappedData.medicalType)}
      </Grid>
    </JobAccordion>
  );
};
